import { combineReducers } from "@reduxjs/toolkit";
import { DigipankSlice } from "./slices/DigipankSlices";
export function createRootReducer() {
  return combineReducers({
    DigipankSlice: DigipankSlice.reducer,
  });
}
